var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "ytPfpControlsLargePlayButtonIconBg",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.726 30.726C27.2109 34.2424 22.968 36 18 36C13.0307 36 8.78914 34.2424 5.274 30.726C1.75757 27.2109 0 22.9693 0 18C0 13.032 1.75757 8.78914 5.274 5.274C8.78914 1.75757 13.0307 0 18 0C22.968 0 27.2109 1.75757 30.726 5.274C34.2424 8.78914 36 13.032 36 18C36 22.9693 34.2424 27.2109 30.726 30.726Z",
  fill: "#000",
  fillOpacity: 0.7
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.0859 18L13.5 25.1717V10.8283L26.0859 18Z",
  fill: "#fff"
})));
export default SvgIconPlay;